<template>
  <div class="card-item p-3">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h3 class="title">Endpoint Stats</h3>

    </div>

    <v-app>
      <v-data-table
          :headers="headers"
          :items="endpointStatsList"
          :items-per-page="100"
          class="elevation-1"
          :search="search">
        <template v-slot:top>
          <v-text-field
              v-model="search"
              label="Arama"
              class="mx-4"/>
        </template>
        <template v-slot:item.userId="{ item }">
          <tr style="width: 50px!important;">
            {{getUserName(item.userId)}}
          </tr>
        </template>
        <template v-slot:item.createDate="{ item }">
          <tr style="width: 50px!important;">
            {{createDate | ddMMyyyyHHmm }}
          </tr>
        </template>
      </v-data-table>
    </v-app>
    <div class="section-block mb-4"></div>
  </div>
</template>

<script>
export default {
  name: "EndpointStatsList",
  data () {
    return {
      search: '',
      headers: [
        {
          text: 'endpoint',
          align: 'start',
          sortable: true,
          value: 'endpoint',
        },
        {
          text: 'count',
          sortable: true,
          value: 'count'
        },
        {
          text: 'avgExecutionTime',
          sortable: true,
          value: 'avgExecutionTime'
        }
      ]
    }
  },
  computed:{
    endpointStatsList : {
      get(){
        return this.$store.getters.getEndpointStatsList;
      }
    },
    userListMap:{
      get(){
        return this.$store.getters.getUserListMap;
      }
    },
  },
  methods:{
    filterCruiseRooms (value, search, item) {
    },
    getUserName(userId){
      if(!this.userListMap || userId === 0) return "";

      return this.userListMap[userId].email;
    }
  },
  mounted() {
    this.$store.dispatch("loadUserList");
  }
}
</script>

<style scoped>

</style>